import { render, staticRenderFns } from "./ContratoPropostaTab.vue?vue&type=template&id=cbddfd4e"
import script from "./ContratoPropostaTab.vue?vue&type=script&lang=js"
export * from "./ContratoPropostaTab.vue?vue&type=script&lang=js"
import style0 from "./ContratoPropostaTab.vue?vue&type=style&index=0&id=cbddfd4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports